__turbopack_context__.v({
  "container": "m89tTq_container",
});
